import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { useNavigate } from 'react-router-dom'
import { Button, Flex, Spinner, Text } from '../../../Components'
import { Column } from 'primereact/column'
import { FC } from '../../../Services/FeathersClient'
import { columnProps } from '../../../Services/Functions'

export const SollecitoList = () => {
  const [solleciti, setSolleciti] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        const res = await FC.service('solleciti').find({ query: { $limit: 100, $sort: { id: -1 } } })
        if (!mounted) return
        const data = Array.isArray(res) ? res : res.data || []
        setSolleciti(data
          ?.sort((a, b) => (new Date(b.createdAt || 0)) - (new Date(a.createdAt || 0)))
          ?.map(s => ({
            ...s,
            emailText: s.emailText ? String(s.emailText).slice(0, 100) + (s.emailText.length > 100 ? '...' : '') : '',
            createdAt: s.createdAt ? new Date(s.createdAt).toLocaleString('it-IT') : ''
          })))
      } catch (e) {
        console.error('Failed to load solleciti', e)
      } finally {
        mounted && setLoading(false)
      }
    }
    load()
    return () => { mounted = false }
  }, [])

  if (loading) return <Spinner />

  return (
    <Flex fw>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Text value='Lista solleciti' size={20} bold />
        <div>
          <Button label='Crea Nuovo' icon='fa-duotone fa-plus' style={{ marginLeft: 10 }} onClick={() => navigate('/sollecito/new')} />
        </div>
      </div>
      <div style={{ marginTop: 12, width: '100%' }}>
        <DataTable
          filterDisplay='row'
          className='TableSignatures' value={solleciti} paginator rows={10} emptyMessage='Nessun sollecito trovato' responsiveLayout='scroll'
        >
          <Column {...columnProps('Titolo')} field='title' />
          <Column {...columnProps('Email')} field='emailText' />
          <Column {...columnProps('N. Email')} field='emailCount' />
          <Column {...columnProps('Data')} field='createdAt' />
          <Column
            {...columnProps('Azioni')}
            body={(r) => (
              <div style={{ display: 'flex', gap: 8 }}>
                <Button label='Vedi' icon='fa-duotone fa-eye' onClick={() => navigate('/sollecito/' + r.id)} />
              </div>
            )}
          />
        </DataTable>
      </div>
    </Flex>
  )
}

export default SollecitoList
